import { useCallback } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useNotifications } from './useNotifications';
import { useLoginModal } from '../contexts/LoginModalContext';

interface UseRequireAuthReturn {
  requireAuth: (callback: () => void, onNotAuthenticated?: () => void) => void;
  isAuthenticated: boolean;
}

export const useRequireAuth = (): UseRequireAuthReturn => {
  const { isAuthenticated } = useAuth();
  const { warning } = useNotifications();
  const { openLoginModal } = useLoginModal();

  const requireAuth = useCallback(
    (callback: () => void, onNotAuthenticated?: () => void) => {
      if (isAuthenticated) {
        callback();
      } else {
        warning('Login Required', 'Please login first to continue');
        openLoginModal();
        if (onNotAuthenticated) {
          onNotAuthenticated();
        }
      }
    },
    [isAuthenticated, warning, openLoginModal]
  );

  return {
    requireAuth,
    isAuthenticated,
  };
};

